module.exports = __webpack_public_path__ + "static/media/image.bd8f3dd7.png";